import type { BaseProductProps } from "../baseProduct/index.client";
import BaseProduct from "../baseProduct/index.client";
import BaseProductVariant from "../baseProductVariant/index.client";

export type ViewOnlyProductProps = Omit<
  BaseProductProps,
  "aboutStockText" | "addToCardButton"
>;

const ViewOnlyProduct = (props: ViewOnlyProductProps) => {
  const { product } = props;
  const { variants } = product || {};
  const hasVariants = variants?.nodes?.length > 1;
  if (hasVariants) {
    return (
      <BaseProductVariant
        {...props}
        aboutStockText={<div className="invisible"></div>}
        addToCardButton={false}
      />
    );
  }
  return (
    <BaseProduct
      {...props}
      aboutStockText={<div className="invisible"></div>}
      addToCardButton={false}
    />
  );
};

export default ViewOnlyProduct;
